<template>
  <section>
    <Title :title-name="titleName" :title-link="title.HotelBook.titleLink" />
    <div v-if="lang && lang['hotel_mobile_new']" class="hotel_book">
      <div class="container my-4">
        <div class="mt-4 select-number-room">
          <ItemOfVouchers icon="hotel-voucher" color="#f0725e" :label="lang['hotel_mobile_new'].SFS_LANG_ROW_1" border />
        </div>
        <div class="my-4 select-number-room">
          <div class="ws-textbox">
            <div class="d-flex align-items-center">
              {{ lang['hotel_mobile_new'].SFS_LANG_ROW_21 }}
              <div>
                <v-select
                  v-model="roomSelect"
                  class="ws-drop-down ws-drop-down--desktop mx-3"
                  :clearable="false"
                  :searchable="false"
                  :filterable="false"
                  :options="optionSelect"
                ></v-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!waitingBook && paxsShareRoom" class="mb-4">
          <MatrixSelect
            :title-matrix="lang['hotel_mobile_new'].SFS_LANG_ROW_22"
            :number="roomSelect"
            :list="paxsShareRoom"
            :is-default-value="isDefaultValue"
            :response-fetch-matrix-hotels="responseFetchMatrixHotels"
            :secret="secret"
            @getListSelected="getListSelected"
            @handleChangeRoomSelect="handleChangeRoomSelect"
          />
        </div>
        <div class="mb-4 text-center">
          <button class="ws-btn hd-normal-btn-background-color hd-normal-btn-color" @click="validationRoomSelected()">
            {{ lang['hotel_mobile_new'].SFS_LANG_ROW_23 }}
          </button>
        </div>
      </div>
      <b-alert
        v-model="showAlertTop"
        class="position-fixed fixed-top m-0 rounded-0"
        style="z-index: 2000; border-radius: 1rem !important; border: 1px solid #ffa5a5; color: #444"
        variant="danger"
        dismissible
      >
        <div v-for="(error, index) in messagesError" :key="index">
          <div>{{ error }}</div>
        </div>
      </b-alert>
    </div>
  </section>
</template>
<script>
import '@/assets/scss/modules/HotelBook.scss'
import { mapGetters } from 'vuex'
import Title from '@/components/Title/index'
import MatrixSelect from '@/components/MatrixSelect/index'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'
import moment from 'moment'

export default {
  name: 'HotelBook',
  components: { Title, MatrixSelect, ItemOfVouchers },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      aRoomNeed: {
        s_room: 0,
        sd_room: 0,
        t_room: 0,
        q_room: 0
      },
      listpaxs: {},
      paxsShareRoom: null,
      waitingBook: false,
      curPaxInfo: null,
      optionSelect: [],
      roomSelect: 0,
      isDefaultValue: false,
      dataRoomSelected: [],
      showAlertTop: false,
      messagesError: [],
      theNumberOfPaxsSelectTheMostRoom: 0,
      payloadSearchHotels: {},
      responseFetchMatrixHotels: {}
    }
  },
  computed: {
    ...mapGetters({
      services: 'HotelList/services',
      hotel: 'Taxi/Taxi',
      dataListHotel: 'HotelList/dataListHotel'
    }),
    titleName() {
      return this.lang['hotel_mobile_new'] ? this.lang['hotel_mobile_new'].SFS_LANG_ROW_28 : 'Home'
    }
  },
  watch: {
    pax: function () {
      if (!this.pax.curPaxID && this.$route.name != 'PaxContactConfirm') {
        this.$router.push({ path: '/pax-contact-confirm', query: { secret: this.secret } })
        return
      }

      if (!_.isEmpty(this.services) && !_.isEmpty(this.PaxsGroup)) {
        this.initData()
      }
    },
    services: function () {
      if (!_.isEmpty(this.pax) && !_.isEmpty(this.PaxsGroup)) {
        this.initData()
      }
    },
    PaxsGroup: function () {
      if (this.PaxsGroup.length < 2) {
        this.$router.push({ path: '/home', query: { secret: this.secret } })
        return
      }
      if (!_.isEmpty(this.pax) && !_.isEmpty(this.services)) {
        this.initData()
      }
    },
    // Auto save matrix when only 1 passenger accept share room
    paxsShareRoom: function () {
      if (this.paxsShareRoom.length === 1) {
        this.paxsShareRoom[0].room = 1
        this.saveMatrixShareRoom()
        this.waitingBook = true
      }
    },
    dataListHotel() {
      this.showAlertTop = false
      this.messagesError = []
      if (!this.dataListHotel.length) {
        this.fetchMatrixHotels()
        return
      }
      this.saveMatrixShareRoom()
    },
    responseFetchMatrixHotels() {
      if (this.responseFetchMatrixHotels.success && !_.isEmpty(this.responseFetchMatrixHotels?.data?.matrix)) {
        this.showAlertTop = true
        let typeRoom = 'Single'
        if (this.theNumberOfPaxsSelectTheMostRoom === 2) {
          typeRoom = 'Double'
        } else if (this.theNumberOfPaxsSelectTheMostRoom === 3) {
          typeRoom = 'Triple'
        } else if (this.theNumberOfPaxsSelectTheMostRoom === 4) {
          typeRoom = 'Quadruple'
        }

        //SFS-5164
        //Create string based on room selection for internal comment
        const roomSelectionByUser = this.dataRoomSelected
          .map((roomNumber, userIndex) => {
            return `User ${userIndex + 1} chose room ${roomNumber}`
          })
          .join('; ')

        //original error message
        this.messagesError.push(
          `There are no hotels with ${typeRoom} rooms available at the moment. Change your room sharing preference.`
        )

        //Internal Comment
        this.$store.dispatch('insertInterCmt', {
          secret: this.$route.query.secret,
          comment: `[SFS.A25102203]: Warning: Requested room allocation unavailable: ${roomSelectionByUser}`
        })

        return
      }
      this.saveMatrixShareRoom()
      if (!this.dataListHotel.length) {
        this.$router.push({ path: '/no-hotels-available', query: { secret: this.secret } })
      }
    },
    showAlertTop() {
      if (this.showAlertTop) {
        setTimeout(() => {
          this.showAlertTop = false
        }, 5000)
      }
    }
  },
  mounted() {
    this.$store.dispatch('HotelList/getServices')
    this.$store.dispatch('Taxi/getTaxi')
    this.$store.dispatch('HotelBook/getPaxsGroup')
  },
  created() {
    if (!_.isEmpty(this.services) && !_.isEmpty(this.PaxsGroup) && !_.isEmpty(this.pax)) {
      this.initData()
    }
  },
  methods: {
    // @TODO: refactor code
    // - 1 passenger & has not matrix share room -> make matrix share room then book hotel
    // - use watch for get state
    saveMatrixShareRoom() {
      let paxsNotShareRoom = _.differenceBy(this.PaxsGroup, this.paxsShareRoom, 'passenger_id')
      let maxRoomNum = _.maxBy(this.paxsShareRoom, 'room')['room']
      _.each(paxsNotShareRoom, function (pax) {
        pax.room = ++maxRoomNum
      })
      let resultMatrix = [...this.paxsShareRoom, ...paxsNotShareRoom]
      var self = this
      self.listpaxs = _.groupBy(
        _.map(resultMatrix, function (obj) {
          var oTmp = {}
          oTmp.passenger_id = obj.passenger_id
          oTmp.room = obj.room
          oTmp.isInfant = self.getInfant(obj) !== -1
          return oTmp
        }),
        function (obj) {
          return obj.room
        }
      )
      var result = Object.keys(self.listpaxs).map(function (key) {
        return self.listpaxs[key]
      })
      _.each(self.listpaxs, function (t) {
        switch (t.length) {
          case 1:
            self.aRoomNeed.s_room++
            break
          case 2:
            self.aRoomNeed.sd_room++
            break
          case 3:
            self.aRoomNeed.t_room++
            break
          case 4:
            self.aRoomNeed.q_room++
            break
          default:
            break
        }
      })

      let dataSendSms = {
        groups_passengers: result,
        paxLeaderId: self.pax.paxLeadId,
        secret: self.secret
      }
      self.$store.dispatch('HotelBook/sendSMSShareroom', dataSendSms).then((response) => {
        if (response.success) {
          self.$router.push({ path: '/hotel-list', query: { secret: self.secret } })
          return
        }
      })
    },
    validationRoomSelected() {
      let self = this
      this.showAlertTop = false
      this.messagesError = []
      const dataRoomSelectedConvert = this.dataRoomSelected.map((item) => parseInt(item))
      const maxNumber = Math.max(...dataRoomSelectedConvert)
      if (_.union(dataRoomSelectedConvert).length !== this.roomSelect || maxNumber > this.roomSelect) {
        this.showAlertTop = true
        this.messagesError.push('Incorrect number of rooms are allocated.')
        return
      }
      let dataRoomSelected = self.getInfoDataRoomSelected()
      let countRoomSelected = _.reduce(dataRoomSelected, (acc, curr) => (acc[curr] ? ++acc[curr] : (acc[curr] = 1), acc), {})
      let isValidSelectRoom = true
      this.theNumberOfPaxsSelectTheMostRoom = 0
      // check passengers choose the same room > 4 -> error
      _.forEach(countRoomSelected, (value) => {
        if (value > 4) {
          isValidSelectRoom = false
        } else {
          if (this.theNumberOfPaxsSelectTheMostRoom < value) {
            this.theNumberOfPaxsSelectTheMostRoom = value
          }
        }
      })
      if (!isValidSelectRoom) {
        this.showAlertTop = true
        this.messagesError.push('The hotel number of rooms greater than 4 people does not exist')
        return
      }
      this.fetchListHotel()
    },
    fetchListHotel() {
      let self = this
      let dataSearchHotel = {
        flight_date: moment(this.pax.flight_date).format('YYYY-MM-DD'),
        secret: this.secret,
        lang_code: this.lang.lang_code,
        aRoomNeed: {
          s_room: 0,
          sd_room: 0,
          t_room: 0,
          q_room: 0
        }
      }
      let dataRoomSelected = self.getInfoDataRoomSelected()
      if (this.PaxsGroup.length == 1) {
        if (self.getInfant(self.PaxsGroup[0]) != -1) {
          self.messagesError.push('Infant must follow adult.')
          return false
        }
        dataSearchHotel.aRoomNeed.s_room++
      } else if (this.dataRoomSelected.length) {
        this.setDefaultRoomForInfant()
        let listPaxs = _.groupBy(dataRoomSelected, (data) => {
          return data
        })
        _.each(listPaxs, (t) => {
          switch (t.length) {
            case 1:
              dataSearchHotel.aRoomNeed.s_room++
              break
            case 2:
              dataSearchHotel.aRoomNeed.sd_room++
              break
            case 3:
              dataSearchHotel.aRoomNeed.t_room++
              break
            case 4:
              dataSearchHotel.aRoomNeed.q_room++
              break
            default:
              break
          }
        })
      } else {
        dataSearchHotel.aRoomNeed.s_room = dataRoomSelected.length
      }
      this.numberRoomNeed = dataSearchHotel.aRoomNeed
      this.payloadSearchHotels = dataSearchHotel
      // fetch list hotel
      this.$store.dispatch('HotelList/updateListHotel', dataSearchHotel)
    },
    fetchMatrixHotels() {
      // fetch Matrix hotels
      this.$store
        .dispatch('HotelList/fetchMatrixHotels', this.payloadSearchHotels)
        .then((response) => {
          this.responseFetchMatrixHotels = _.cloneDeep(response)
        })
        .catch((e) => {
          console.log(e)
        })
    },
    initData() {
      let self = this

      if (this.PaxsGroup.length < 2) {
        this.$router.push({ path: '/hotel-list', query: { secret: this.secret } })
        return
      }
      if (self.pax.has_cancelled_hotel_voucher) {
        // Has cancelled hotel voucher
        self.$router.push({ path: '/home', query: { secret: self.secret } })
        return
      }
      // create pax to share room
      this.paxsShareRoom = _.filter(this.PaxsGroup, function (pax) {
        // get if it is leader or not invited companion or companion who accept to share room
        return (
          !pax.params.travel_together ||
          !pax.params.travel_together.leader_id ||
          pax.params.travel_together.confirm_manage_book === 1
        )
      })
      this.roomSelect = this.paxsShareRoom.filter((pax) => {
        return self.getInfant(pax) == -1
      }).length
      this.optionSelect = _.range(1, this.paxsShareRoom.length + 1)

      if (
        !_.isEmpty(this.services) &&
        !_.isNull(this.services[1].params) &&
        !_.isUndefined(this.services[1].params.matrix_share_room)
      ) {
        let matrixShareRoomData = this.services[1].params.matrix_share_room
        // recalculate number of room that matrix selected
        this.roomSelect = _.uniqBy(matrixShareRoomData, 'room').length
        // Exists matrix share room
        _.forEach(matrixShareRoomData, (value) => {
          let indexPaxsShareRoom = _.findIndex(this.paxsShareRoom, (o) => o.passenger_id == value.passenger_id)
          this.$set(this.paxsShareRoom[indexPaxsShareRoom], 'room', value.room)
        })
        this.isDefaultValue = true
        return
      }

      self.curPaxInfo = _.find(self.PaxsGroup, { passenger_id: parseInt(self.pax.curPaxID) })
    },
    getListSelected(dataSelected) {
      // fill room selected in paxsShareRoom
      _.forEach(dataSelected, (value, key) => {
        this.$set(this.paxsShareRoom[key], 'room', value)
      })
      this.dataRoomSelected = _.cloneDeep(dataSelected)
    },
    handleChangeRoomSelect(data) {
      this.roomSelect = data.number || this.roomSelect
    },
    getInfant(pax) {
      let string = pax.invoicing_flag
      if (pax && !_.isUndefined(pax.invoicing_flag) && !_.isNull(pax.invoicing_flag) && !_.isEmpty(pax.invoicing_flag)) {
        let position = string.search('INFT')
        if (position == -1) {
          position = string.search('INF')
        }
        return position
      } else {
        let ssrs = pax.ssrs
        var v = ssrs.findLastIndex((o) => o.type == 'INFT')
        if (v != -1) {
          return v
        }
        return ssrs.findLastIndex((o) => o.type == 'INF')
      }
    },
    isInfant(pax) {
      let ssrs = pax.ssrs
      if (!_.isUndefined(ssrs) && pax.invoicing_flag == 'INFT') {
        let invoicing_flag = _.find(ssrs, function (ssr) {
          return ssr.type == 'INFT'
        })
        if (!invoicing_flag) {
          //define ssr object via amadeus
          let infant = {
            type: 'INFT',
            key: '#INFT',
            ssrValue: {}
          }
          ssrs.push(infant)
        }
      }
      let result = _.find(ssrs, function (ssr) {
        return ssr.type == 'INFT'
      })
      if (result) {
        return true
      } else {
        return false
      }
    },
    setDefaultRoomForInfant() {
      let paxs = this.PaxsGroup
      let dataRoom = this.dataRoomSelected
      let paxsShareRoom = this.paxsShareRoom
      let min = 1e9
      //get first room
      _.forEach(paxs, (pax, index) => {
        if (this.getInfant(pax) == -1) {
          if (this.dataRoomSelected[index] < min) {
            min = this.dataRoomSelected[index]
          }
        }
      })
      //set room for infant
      _.forEach(paxs, (pax, index) => {
        if (this.getInfant(pax, index) !== -1) {
          this.dataRoomSelected[index] = min
        }
      })

      if (paxsShareRoom && !_.isEmpty(paxsShareRoom) && !_.isUndefined(paxsShareRoom)) {
        _.map(this.paxsShareRoom, (pax, index) => {
          return (pax.room = this.dataRoomSelected[index])
        })
      }
    },
    getInfoDataRoomSelected() {
      let self = this
      let dataRoomSelected = []
      _.forEach(self.dataRoomSelected, (room, index) => {
        let pax = self.PaxsGroup[index]
        if (!self.isInfant(pax)) {
          dataRoomSelected.push(room)
        }
      })
      return dataRoomSelected
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .vs__dropdown-menu,
.ws-drop-down {
  min-width: 70px;
  width: 70px;
}
::v-deep .ws-drop-down .vs__dropdown-toggle {
  padding: 0;
}
</style>
